/* eslint-disable import/first */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
const { fetchProductsByCategoryId, addNewProduct } = Slices.productSlice;
const { setMenuFetch, isMenuFetched } = Slices.appSlice;
const { shouldRefetch, setRefetch } = Slices.categorySlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { getClusterId, selectCountryValidations } = Slices.configSlice;

// const { selectDesktop } = Slices.appSlice;

const FetchValues = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [shouldFetch, setShouldFetch] = useState(true);
  const categories = useSelector((state) => state.category);
  // const isDesktop = useSelector(selectDesktop);
  const intl = useIntl();
  const isMenuItemExist = useSelector(isMenuFetched);
  const clusterId = useSelector(getClusterId);
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const profile = useSelector((state) => state.profile);
  // const cart = useSelector((state) => state.cart);
  const bogoProducts = useSelector((state) => state.product.bogoProdList);
  const shouldRefetchCategories = useSelector(shouldRefetch);
  const menu = useSelector((state) => state.profile);
  let bogo = {};

  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  const checkIfInsideTiming = (startTime, endTime) => {
    let date = new Date(
      new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
    );
    let start = startTime.split(':');
    let end = endTime.split(':');

    const startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(start[0]),
      parseInt(start[1]),
      0
    );

    const endDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(end[0]),
      parseInt(end[1]),
      0
    );

    return startDate.getTime() <= date.getTime() && date.getTime() <= endDate.getTime();
  };

  const defaultTimings = { from: '00:00', to: '00:00' };
  const currentDayOfWeek =
    days[
      new Date(
        new Date().toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
      ).getDay()
    ];

  const checkIfAvil = (displayDays) => {
    let isItemAvailable = true;
    if (Object.values(displayDays || {}).length === 0) {
      isItemAvailable = true;
    } else {
      // debugger;
      const dayTimings = displayDays?.[currentDayOfWeek] || defaultTimings;
      let dealFallsInTiming = false;

      for (let timing of Array.isArray(dayTimings)
        ? dayTimings
        : Object.keys(dayTimings || {}).length > 0
        ? [dayTimings]
        : []) {
        if (checkIfInsideTiming(timing?.from, timing?.to)) {
          dealFallsInTiming = true;
          break;
        }
      }
      if (!dealFallsInTiming) {
        isItemAvailable = false;
      }
    }
    return isItemAvailable;
  };

  // eslint-disable-next-line no-unused-expressions
  useEffect(() => {
    let subCategories = Object.values(categories?.entities || {})
      .filter((cat) => cat.parentId > 0 && checkIfAvil(cat?.availableSlot || {}))
      .sort((a, b) => b.level - a.level)
      .map((e) => e.id);

    let allCategories = categories.ids;

    const fetchProducts = async () => {
      let categoryList;
      if (!isMenuItemExist) {
        categoryList = allCategories;
      } else {
        if (shouldRefetchCategories) {
          categoryList = [...subCategories, ...allCategories];
        } else {
          categoryList = subCategories;
        }
      }

      categoryList = categoryList.filter((c) => c !== 999);

      categoryList = categoryList.filter((value, index, array) => array.indexOf(value) === index);

      await Promise.allSettled(
        categoryList.map(async (id) => {
          await dispatch(
            fetchProductsByCategoryId({
              id: id,
              cluster: clusterId,
              Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
            })
          ).then((resp) => {
            if (resp?.payload?.bogoProducts?.id) {
              bogo[resp?.payload?.bogoProducts?.id] = resp?.payload?.bogoProducts.list;
            }
          });
        })
      ).then((resp) => {
        dispatch(setMenuFetch());
        setShouldFetch(false);
        dispatch(setRefetch({ refetch: false }));
        handleBOGOProduct();
      });
    };

    const fetchSubCategories = async () => {
      let categoryList = subCategories;
      categoryList = categoryList.filter((value, index, array) => array.indexOf(value) === index);

      if (countryValidations.makeYourOwnPizza?.categoryId > 0) {
        categoryList.push(countryValidations.makeYourOwnPizza?.categoryId);
      }

      await Promise.allSettled(
        categoryList.map(async (id) => {
          await dispatch(
            fetchProductsByCategoryId({
              id: id,
              cluster: clusterId,
              Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
            })
          ).then((resp) => {
            if (resp?.payload?.bogoProducts?.id) {
              bogo[resp?.payload?.bogoProducts?.id] = resp?.payload?.bogoProducts.list;
            }
          });
        })
      ).then((resp) => {
        dispatch(setMenuFetch());
        dispatch(setRefetch({ refetch: false }));
        setShouldFetch(false);
        handleBOGOProduct();
      });
    };

    if (menu?.status === 'succeeded' && shouldRefetchCategories && shouldFetch) {
      fetchProducts();
    } else if (menu?.status === 'succeeded' && !shouldRefetchCategories && shouldFetch) {
      fetchSubCategories();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu.status, intl.locale, shouldRefetchCategories]);

  const handleBOGOProduct = () => {
    // add bogo and other hidden deals
    const bogoCat = Object.values(categories?.entities || {}).filter((cat) => cat?.code === 'BOGO');
    let categoryData = categories?.entities[bogoCat[0]?.id];
    if (!checkIfAvil(categoryData?.availableSlot)) {
      categoryData = null;
    }
    let subCategories = categoryData ? [categoryData] : [];

    subCategories = subCategories.map((subCategory) => {
      let subCategoryVariants = Object.values(categories?.entities || {}).filter(
        (subCategortVariant) => subCategortVariant?.parentId == subCategory?.id
      );

      subCategoryVariants = JSON.parse(JSON.stringify(subCategoryVariants));
      let products = [];
      let variantsArray = [];
      for (let i = 0; i < subCategoryVariants?.length; i++) {
        const steps = [
          {
            aKey: 'PHD_AE_v20_7_22_359_10598_1',
            assets: [{}],
            clusterKey: 'PHD_AE_v20_7_22',
            compId: parseInt(subCategoryVariants[i]?.id) * 10 + 1,
            groupId: 'PHD_AE_v20_7_22_359_10598',
            id: parseInt(subCategoryVariants[i]?.id) * 10 + 1,
            ingredient: 0,
            isAddon: 0,
            isDependent: 0,
            isHidden: 0,
            isModifier: 0,
            maximum: 1,
            minimum: 1,
            options: bogo[subCategoryVariants[i]?.id],
            sCustomize: 1,
            subtitle: intl.formatMessage({ id: 'select_first_pizza' }),
            title: intl.formatMessage({ id: 'select_first_pizza' }),
            type: 'radio',
          },
          {
            aKey: 'PHD_AE_v20_7_22_359_10598_1',
            assets: [{}],
            clusterKey: 'PHD_AE_v20_7_22',
            compId: parseInt(subCategoryVariants[i]?.id) * 10 + 2,
            groupId: 'PHD_AE_v20_7_22_359_10598',
            id: parseInt(subCategoryVariants[i]?.id) * 10 + 2,
            ingredient: 0,
            isAddon: 0,
            isDependent: 0,
            isHidden: 0,
            isModifier: 0,
            maximum: 1,
            minimum: 1,
            options: bogo[subCategoryVariants[i]?.id],
            sCustomize: 1,
            subtitle: intl.formatMessage({ id: 'select_second_pizza' }),
            title: intl.formatMessage({ id: 'select_second_pizza' }),
            type: 'radio',
          },
        ];

        variantsArray.push({
          isSelected: 0,
          title: subCategoryVariants[i]['name'],
          description: subCategoryVariants[i]['description'],
          id: subCategoryVariants[i]['id'],
        });

        products = products.concat({
          ...subCategoryVariants[i],
          sel1Value: subCategoryVariants[i]['id'],
          steps: steps,
          isHiddenDeal: true,
          isBOGO: true,
        });
      }
      const productStructure = {
        ...subCategory,
        categories: [subCategory?.parentId],
        variants: [
          {
            position: 1,
            orientation: 'vertical',
            id: 9999,
            selIndex: 1,
            title: intl.formatMessage({ id: 'please_choose_deal_size' }),
            subtitle: intl.formatMessage({ id: 'please_choose_deal_size' }),
            options: variantsArray,
          },
        ],
        items: products,
        bundleTypeId: 'bundle_group',
        typeId: 'bundle_group',
        isHiddenDeal: true,
        isBOGO: true,
      };

      dispatch(addNewProduct(productStructure));

      return productStructure;
    });
  };
  return '';
});

export default FetchValues;
